/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';

import GetAllRegions from '@/services/GetAllRegions';
import DeliveryScheduleRelocationCollectionView from '@/views/DeliveryScheduleRelocationCollectionView';

import GetOrderPackageRelocationDeliverySchedules from '../services/GetOrderPackageRelocationDeliverySchedules';
import GetCONUSAndOCONUSRegions from '../../order/services/GetCONUSAndOCONUSRegions';

export default async function loadOrderPackageRelocationDeliveryScheduleGridView({
  orderPackageID,
  editable,
  orderPackage
}) {
  const [regions, schedules, conusOconusRegions] = await Promise.all([
    GetAllRegions(),
    GetOrderPackageRelocationDeliverySchedules(orderPackageID),
    GetCONUSAndOCONUSRegions()
  ]);

  formatSchedules(schedules);

  // Assign regions to each model for the modal view
  _.each(schedules, (schedule) => {
    schedule.regions = regions?.filter((region) => region?.isSpecialty === 'false');
    schedule.conusOconusRegions = conusOconusRegions;
  });

  const scheduleCollection = new Backbone.Collection(schedules);

  return new DeliveryScheduleRelocationCollectionView({
    editable,
    collection: scheduleCollection
  });
}

function formatSchedules(schedules) {
  const lastIdx = schedules.length - 1;
  _.each(schedules, (schedule, i) => {
    schedule.equipmentName = schedule?.deviceMake?.concat(' ', schedule?.deviceModel);
    const fromDevice = Object.assign({}, schedule);
    const toDevice = Object.assign({}, schedule);

    fromDevice.deliveryPOCFirstName = schedule.fromDeliveryPOC?.deliveryPOCFirstName || '';
    fromDevice.deliveryPOCLastName = schedule.fromDeliveryPOC?.deliveryPOCLastName || '';
    fromDevice.deliveryPOCName =
      schedule.fromDeliveryPOCName || `${fromDevice.deliveryPOCFirstName} ${fromDevice.deliveryPOCLastName}`;
    fromDevice.deliveryPOCEmail = schedule.fromDeliveryPOC?.deliveryPOCEmail;
    fromDevice.deliveryPOCPhone = schedule.fromDeliveryPOC?.deliveryPOCPhone;

    fromDevice.itPOCFirstName = schedule.fromITPOC?.itPOCFirstName || '';
    fromDevice.itPOCLastName = schedule.fromITPOC?.itPOCLastName || '';
    fromDevice.itPOCName = schedule.fromITPOCName || `${fromDevice.itPOCFirstName} ${fromDevice.itPOCLastName}`;
    fromDevice.itPOCEmail = schedule.fromITPOC?.itPOCEmail;
    fromDevice.itPOCPhone = schedule.fromITPOC?.itPOCPhone;

    fromDevice.organization = schedule.fromOrgUnit;
    fromDevice.base = schedule.fromBase;

    toDevice.deliveryPOCFirstName = schedule.toDeliveryPOC?.deliveryPOCFirstName || '';
    toDevice.deliveryPOCLastName = schedule.toDeliveryPOC?.deliveryPOCLastName || '';
    toDevice.deliveryPOCName =
      schedule.toDeliveryPOCName || `${toDevice.deliveryPOCFirstName} ${toDevice.deliveryPOCLastName}`;
    toDevice.deliveryPOCEmail = schedule.toDeliveryPOC?.deliveryPOCEmail;
    toDevice.deliveryPOCPhone = schedule.toDeliveryPOC?.deliveryPOCPhone;

    toDevice.itPOCFirstName = schedule.toITPOC?.itPOCFirstName || '';
    toDevice.itPOCLastName = schedule.toITPOC?.itPOCLastName || '';
    toDevice.itPOCName = schedule.toITPOCName || `${toDevice.itPOCFirstName} ${toDevice.itPOCLastName}`;
    toDevice.itPOCEmail = schedule.toITPOC?.itPOCEmail;
    toDevice.itPOCPhone = schedule.toITPOC?.itPOCPhone;

    toDevice.organization = schedule.toOrgUnit;
    toDevice.base = schedule.toBase;

    fromDevice.address = schedule.fromAddress;
    toDevice.address = schedule.toAddress;

    schedule.fromDevice = fromDevice;
    schedule.toDevice = toDevice;
    schedule.isLastIndex = i === lastIdx;
  });
}
